exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".select-user-table .sphere-table-container{position:relative !important}.select-user-table .k-grid-container{max-height:calc(100vh - 480px)}.select-user-table .k-grid-container .sb_NoDataAvialable{justify-content:left;text-align:left}.select-user-table .k-grid-container .sb_NoDataAvialable .v-icon{color:rgba(0,0,0,0.3);font-size:24px;margin-right:15px}.select-user-table .k-grid-container .sb_NoDataAvialable>div{color:#fff}\n", ""]);

// exports
